module.exports = __webpack_public_path__ + "img/error_bg.e0601857.svg";